import { TooltipArrow, TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from "reka-ui";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";

export default defineComponent({
  name: "Tooltip",
  inheritAttrs: false,
  props: {
    text: String,
    delay: p.number(300),
    align: p.string<"center" | "start" | "end">("center"),
    alignOffset: p.number(0),
    side: p.string<"top" | "right" | "bottom" | "left">("top"),
  },
  setup(props, { slots, attrs }) {
    return () =>
      props.text ? (
        <TooltipRoot
          delayDuration={props.delay}
          disableClosingTrigger={false}
          ignoreNonKeyboardFocus={true}
        >
          <TooltipTrigger asChild>{slots.default?.()}</TooltipTrigger>
          {/* Portaled to <body>: rendered inline, the content inherited the
              trigger's opacity (a disabled row), weight and size. */}
          <TooltipPortal>
            <TooltipContent
              asChild
              align={props.align}
              alignOffset={props.alignOffset}
              side={props.side}
              avoidCollisions
              collisionPadding={8}
              sideOffset={6}
              sticky="always"
              onPointerDownOutside={() => {
                // Smart global solution: Close tooltip when clicking outside
                // This handles modal interactions automatically
              }}
              class={cn(
                "z-90 max-w-80 overflow-hidden text-wrap break-words rounded-md bg-tooltip px-3 py-1.5 text-xs font-normal leading-snug text-[hsl(210,40%,98%)] animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
                attrs.class ?? ""
              )}
            >
              <p>{props.text}</p>
              <TooltipArrow class="fill-tooltip" />
            </TooltipContent>
          </TooltipPortal>
        </TooltipRoot>
      ) : (
        <>{slots.default?.()}</>
      );
  },
});
